import React from 'react';
import { withTranslation } from 'react-i18next';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
// assets
// import TwoCone from 'assets/images/TwoCone.png';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // 렌더링 중 에러가 발생하면 호출
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // 에러 로깅
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    // 필요 시 Sentry 등으로 전송
  }

  render() {
    // const { t } = this.props;
    if (this.state.hasError) {
      return (
        <>
          <Grid
            container
            spacing={10}
            direction="column"
            alignItems="center"
            justifyContent="center"
            sx={{ minHeight: '100vh', pt: 1.5, pb: 1, overflow: 'hidden', backgroundColor:"#efefef" }}
          >
            {/* <Grid item xs={12}>
              <Stack direction="row">
                <Grid item sx={{ position: 'relative' }}>
                  <Box sx={{ position: 'absolute', top: 60, left: -40, width: { xs: 130, sm: 390 }, height: { xs: 115, sm: 330 } }}>
                    <img src={TwoCone} alt="mantis" style={{ width: '100%', height: '100%' }} />
                  </Box>
                </Grid>
              </Stack>
            </Grid> */}
            <Grid item xs={12}>
              <Stack spacing={2} justifyContent="center" alignItems="center">
                <Typography variant="h1" style={{backgroundColor:"#efefef",color:"#000"}}>문제가 발생했습니다.</Typography>
                <Typography color="textSecondary" align="center" sx={{ width: { xs: '73%', sm: '61%' } }} style={{backgroundColor:"#efefef",color:"#000"}}>
                  <h2>새로고침하거나, 로그인 상태를 확인해주세요.</h2>
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </>
      );
      // return (
      //   <div style={{ padding: 40, textAlign: 'center' }}>
      //     <h2>문제가 발생했습니다.</h2>
      //     <p>새로고침하거나, 로그인 상태를 확인해주세요.</p>
      //   </div>
      // );
    }

    return this.props.children;
  }
}

export default withTranslation()(ErrorBoundary);
